import React from 'react';

import SvgContainer from '../SvgContainer';

const Caution = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9078_100936)">
                <path d="M0.146446 13.6275C-0.272275 14.3602 0.256824 15.2719 1.10078 15.2719H14.8992C15.7432 15.2719 16.2723 14.3602 15.8536 13.6275L8.95434 1.55382C8.53238 0.815392 7.46762 0.815393 7.04566 1.55382L0.146446 13.6275ZM8.79939 12.0428C8.79939 12.4843 8.44149 12.8422 8 12.8422C7.55851 12.8422 7.20061 12.4843 7.20061 12.0428V12.0218C7.20061 11.5803 7.55851 11.2224 8 11.2224C8.44149 11.2224 8.79939 11.5803 8.79939 12.0218V12.0428ZM8.79939 8.80322C8.79939 9.24471 8.44149 9.60261 8 9.60261C7.55851 9.60261 7.20061 9.24471 7.20061 8.80322V6.35246C7.20061 5.91097 7.55851 5.55308 8 5.55308C8.44149 5.55308 8.79939 5.91097 8.79939 6.35246V8.80322Z" />
            </g>
            <defs>
                <clipPath id="clip0_9078_100936">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Caution;
